import { render } from "./EnSmallLabeledContent.vue?vue&type=template&id=ea339798&scoped=true"
import script from "./EnSmallLabeledContent.vue?vue&type=script&setup=true&lang=js"
export * from "./EnSmallLabeledContent.vue?vue&type=script&setup=true&lang=js"

import "./EnSmallLabeledContent.vue?vue&type=style&index=0&id=ea339798&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea339798"],['__file',"Shared/components/text/EnSmallLabeledContent/EnSmallLabeledContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea339798"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea339798', __exports__)) {
    api.reload('ea339798', __exports__)
  }
  
  module.hot.accept("./EnSmallLabeledContent.vue?vue&type=template&id=ea339798&scoped=true", () => {
    api.rerender('ea339798', render)
  })

}


export default __exports__